<template>
  <div class="confirm-kantei">
    <form :action="action" :method="method" @submit="showLoading = true">
      <input type="hidden" name="_token" :value="token" />
      <p class="confirm-kantei__text">下記の内容で占いを申し込みます。</p>
      <dl class="confirm-list">
        <dt class="confirm-list__title">占いたいこと</dt>
        <dd class="confirm-list__data">{{ confirmData.themeq }}</dd>
        <dt class="confirm-list__title">さらに詳しく</dt>
        <dd class="confirm-list__data">{{ confirmData.keyword }}</dd>
        <dt class="confirm-list__title confirm-list__title--worry">お悩み</dt>
        <dd class="confirm-list__data confirm-list__data--worry">{{ confirmData.worried }}</dd>
        <dt class="confirm-list__title">ニックネーム</dt>
        <dd class="confirm-list__data">{{ confirmData.nickname }}</dd>
        <dt class="confirm-list__title">生年月日</dt>
        <dd class="confirm-list__data">{{ confirmData.birthDay | adjustBirthDay }}</dd>
        <dt class="confirm-list__title">性別</dt>
        <dd class="confirm-list__data">{{ confirmData.gender }}</dd>
        <dt class="confirm-list__title">出生時間</dt>
        <dd class="confirm-list__data">
          <template v-if="confirmData.birthTime">
            {{ confirmData.birthTime | adjustBirthTime }}
          </template>
        </dd>
        <dt class="confirm-list__title">出生地</dt>
        <dd class="confirm-list__data">
          <template v-if="confirmData.fromPref">
            {{ confirmData.fromPref }}
          </template>
        </dd>
        <template v-if="confirmData.targetBirthday">
          <dt class="confirm-list__title">相手の生年月日</dt>
          <dd class="confirm-list__data">{{ confirmData.targetBirthday | adjustBirthDay }}</dd>
        </template>
      </dl>
      <dl class="point-list">
        <dt class="point-list__title">保有ポイント</dt>
        <dd class="point-list__data">{{ userProfile.user_point | addComma }}pt</dd>
        <dt class="point-list__title">利用ポイント</dt>
        <dd class="point-list__data">-{{ consumptionPoint | addComma }}pt</dd>
        <dt class="point-list__title">総保有ポイント</dt>
        <dd class="point-list__data">{{ remainingPoints | addComma }}pt</dd>
      </dl>
      <div class="confirm-kantei__foot">
        <submit-button
          type="button"
          text="戻る"
          class="confirm-kantei__back"
          :disabled="showLoading"
          @click="clickBack"
        />
        <submit-button
          type="submit"
          text="OK"
          design="fill"
          class="confirm-kantei__submit"
          :disabled="showLoading"
        />
        <app-loading :is-loading="showLoading" />
      </div>
    </form>
  </div>
</template>

<script>
import SubmitButton from "../partials/SubmitButton"

export default {
  name: "ConfirmKantei",
  components: {
    SubmitButton
  },
  props: {
    confirmData: {
      type: Object,
      default () {
        return {}
      }
    },
    userProfile: {
      type: Object,
      default () {
        return {}
      }
    },
    consumptionPoint: {
      type: Number | String,
      default: 900
    },
    action: String,
    method: String,
    token: String
  },
  data() {
    return {
      // loading の表示
      showLoading: false
    }
  },
  computed: {
    // 残りのポイント
    remainingPoints () {
      return Number(this.userProfile.user_point) - Number(this.consumptionPoint)
    }
  },
  filters: {
    // 生年月日を調整
    adjustBirthDay (value) {
      value = String(value)
      return value.slice(0, 4) + '/' + value.slice(4, 6) + '/' + value.slice(-2)
    },
    // 生年月日を調整
    adjustBirthTime (value) {
      value = String(value)
      return value.slice(0, 2) + ':' + value.slice(-2)
    }
  },
  methods: {
    clickBack () {
      location.href = `/favor/contents`
      //history.back()
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.confirm-kantei {
  color: $col_base_black;
  padding: 30px 4px 60px;
  &__text {
    font-weight: bold;
    font-size: 13px;
    line-height: 19px;
    margin: 0 0 36px;
  }
  &__foot {
    display: flex;
    margin: 0 -7.5px;
  }
  &__back,
  &__submit {
    flex: 1 1 auto;
    margin: 0 7.5px;
  }
}

$thWidth: 105px;
.confirm-list {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #DCDFE2;
  border-radius: 10px;
  padding: 0 20px;
  margin: 0 0 20px;
  &__title,
  &__data {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #DCDFE2;
    margin: 0;
    &:last-of-type {
      border-bottom: none;
    }
  }
  &__title {
    flex: 1 1 $thWidth;
    color: #656D78;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    padding: 14px 0;
    &--worry {
      flex: 1 1 $thWidth;
      border-bottom: none;
      padding-bottom: 3px;
    }
  }
  &__data {
    flex: 1 1 calc(100% - #{$thWidth});
    font-size: 14px;
    line-height: 21px;
    padding: 15px 0 13px;
    &--worry {
      flex: 1 1 100%;
      font-size: 13px;
      text-align: justify;
      padding-top: 0;
      word-break: break-word;
    }
  }
}
.point-list {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #DCDFE2;
  border-radius: 10px;
  padding: 0;
  margin: 0 0 35px;
  &__title,
  &__data {
    display: flex;
    align-items: center;
    margin: 0;
    &:last-of-type {
      border-top: 1px solid #DCDFE2;
    }
  }
  &__title {
    flex: 1 1 $thWidth;
    color: #656D78;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    padding: 5px 0 5px 20px;
    &:first-of-type {
      padding-top: 12px;
    }
    &:nth-last-of-type(2) {
      padding-bottom: 14px;
    }
    &:last-of-type {
      border-top: 1px solid #DCDFE2;
      padding-top: 12px;
      padding-bottom: 14px;
    }
  }
  &__data {
    flex: 1 1 calc(100% - #{$thWidth});
    justify-content: flex-end;
    font-size: 14px;
    line-height: 21px;
    padding: 6px 20px 4px 10px;
    &:first-of-type {
      padding-top: 13px;
    }
    &:nth-last-of-type(2) {
      padding-bottom: 13px;
    }
    &:last-of-type {
      border-top: 1px solid #DCDFE2;
      padding-top: 13px;
      padding-bottom: 13px;
    }
  }
}
.loading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 100001;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Favor/ConfirmKantei.vue